import { StatusPanelController } from "./status-panel/status-panel.controller";
import lodash from "lodash";

/* globals angular, _, $ */
(function () {
  "use strict";

  /*@ngInject*/
  function PackagesListCtrl(
    $window,
    $scope,
    $rootScope,
    $mdPanel,
    $mdToast,
    $mdSidenav,
    $filter,
    $state,
    $stateParams,
    $tour,
    AtendimentoResource,
    Historico,
    PrintLabel,
    Pedido,
    localStorageService,
    Cliente,
  ) {
    var $ctrl = this;

    $ctrl.ticketSelectedEmail = null;
    $ctrl.ticketEmail = null;
    $ctrl.ordenacao = "desc";

    $ctrl.table = {
      config: {
        showNotFound: false,
        showAtrasadas: false,
        showAlertUnvisible: false,
        rowSelection: false,
        multiSelect: true,
        autoSelect: true,
        hideColumnVisible: true,
        packages: [],
        notFound: [],
        selected: [],
        page: 1,
        pages: null,
        limitPerPage: 100,
        visibleFilter: "visible",
        loading: {
          page: null,
          btnLoading: null,
          printLabels: null,
        },
        showBtnLoading: null,
      },
    };

    $ctrl.table.reset = angular.copy($ctrl.table.config);

    $ctrl.panelDelay = null;

    $ctrl.filter = {
      global: {
        config: {
          select: {
            title: "Select",
            options: [
              {
                name: "cep",
                displayName: "CEP",
                code: 0,
              },
              {
                name: "rastreamento",
                displayName: "Rastreamento",
                code: 1,
              },
              {
                name: "nomeDestinatario",
                displayName: "Nome do destinátario",
                code: 2,
              },
              {
                name: "documentoDestinatario",
                displayName: "CPF/CNPJ",
                code: 3,
              },
              {
                name: "referencia",
                displayName: "Pedido/Referência",
                code: 4,
              },
            ],
            isSelected: {
              name: "nomeDestinatario",
              displayName: "Nome do destinátario",
              code: 2,
            },
          },
          text: {
            title: "Text",
            options: {
              name: "content",
              displayName: "Buscar por",
              code: "3",
              isText: null,
            },
          },
        },
        current: null,
      },
    };

    $ctrl.filter.reset = angular.copy($ctrl.filter.global);

    $ctrl.isOpenDetail = false;

    function enableDisableLoading(key, active) {
      var disableList = _.isArray(key) ? key : [key];
      var isActivated = active;
      _.forEach(disableList, function (loading) {
        _.forIn($ctrl.table.config.loading, function (value, key) {
          if (key === loading) {
            $ctrl.table.config.loading[key] = isActivated;
          }
        });
      });
    }

    $ctrl.updateLoadData = function () {
      enableDisableLoading("page", true);
      loadData();
    };

    $ctrl.isNotNEPP = function () {
      return !localStorageService.get("user").isNEPP;
    };

    // Função separada para carregar contadores (sempre executada no $onInit)
    // Isso garante que os badges laterais sempre sejam populados
    function loadCounters() {
      Historico.getContadorNaoEncontradas()
        .then(function (data) {
          $ctrl.table.config.naoEncontradas = data.naoEncontradas;
        })
        .catch(function (err) {
          console.log(err);
        });

      Historico.getContadorAtrasadas()
        .then(function (data) {
          $ctrl.table.config.atrasos = data.encomendasAtrasadas;
        })
        .catch(function (err) {
          console.log(err);
        });

      Historico.getCustomFilter()
        .then(function (data) {
          $ctrl.table.config.acoesPendentes = {
            emProcessamento: data.acoesPendentes.emProcessamento,
            enviadas: data.acoesPendentes.enviadas,
          };
          $ctrl.table.config.notificacoes = {
            emProcessamento: data.notificacoes.emProcessamento,
            enviadas: data.notificacoes.enviadas,
          };
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function loadData() {
      var offset =
        $ctrl.table.config.page > 1 ? $ctrl.table.config.packages.length : 0;
      var limit = $ctrl.table.config.limitPerPage;

      $ctrl.table.config.hideColumnVisible = false;
      if ($ctrl.table.config.page === 1) {
        $ctrl.table.config.packages = [];
      }

      // Carregar contadores
      loadCounters();

      if (!$ctrl.filter.global.current) {
        $ctrl.filter.global.current = {};
      }

      if (!$ctrl.filter.global.current.situacoes) {
        $ctrl.filter.global.current.situacoes = [
          "Nova,EmProcessamento,Enviada,EmDevolucao,AguardandoRetiradaDestinatario",
        ];
      }

      Historico.getPackages($ctrl.filter.global.current, offset, limit)
        .then(function (packages) {
          $ctrl.table.config.packages = $ctrl.table.config.packages.concat(
            packages.encomendas
          );
          $ctrl.table.config.totalItems = $ctrl.table.config.packages.length;
          $ctrl.table.config.total = packages.quantidade;
          $ctrl.table.config.pages = Math.ceil(
            packages.quantidade / $ctrl.table.config.limitPerPage
          );
          for (var p in packages.encomendas) {
            if (
              packages.encomendas[p].rastreamentoRemessa
                .dataHoraAceiteOcorrencia != null
            ) {
              if (!$ctrl.table.config.showAlertUnvisible)
                $ctrl.table.config.showAlertUnvisible = true;
              packages.encomendas[p].isHideByFilter = true;
            }
          }

          $ctrl.table.config.packages = lodash.orderBy(
            $ctrl.table.config.packages,
            "entrega.tentativa",
            "desc"
          );

          enableDisableLoading(["page", "btnLoading"], null);
        })
        .catch(function (err) {
          console.log(err);
          $ctrl.table.config.showAlertUnvisible = false;
          $ctrl.table.config.totalItems = 0;
          enableDisableLoading(["page", "btnLoading"], null);
          $ctrl.table.config.packages = [];
          $ctrl.table.config.notFound = [];
          $ctrl.table.config.total = 0;
        });
    }

    this.$onInit = function () {
      $ctrl._mdPanel = $mdPanel;
      $ctrl._mdToast = $mdToast;
      _trackEvents(
        {
          userId: localStorageService.get("user").email,
        },
        "Module:Ocorrencia:PageView"
      );
      if (location.search) {
        $ctrl.filter.global.current = {
          codigoRastreamento: location.search.match(/\?(\w*)/)[1],
        };
      }

      // Sempre carregar contadores, independente do filtro selecionado
      loadCounters();

      // Usar if-else-if para evitar múltiplas execuções simultâneas
      // Isso previne que loadData() e filterResumoAtraso() executem ao mesmo tempo,
      // o que causava duplicação de dados ao navegar do dashboard para "Em atraso"
      if ($stateParams.acoesPendentes) {
        $ctrl.filterResumo(
          "Ação pendente",
          "EmProcessamento,Nova,Enviada,EmDevolucao,AguardandoRetiradaDestinatario"
        );
      } else if ($stateParams.emAtraso) {
        // Agora executa APENAS filterResumoAtraso, sem chamar loadData() antes
        $ctrl.filterResumoAtraso(true);
      } else {
        loadData();
      }

      if ($stateParams.tour) {
        startTour();
      }

      enableDisableLoading("page", true);
    };

    $ctrl.closeAlertUnvisible = function (e) {
      e.stopPropagation();
      $ctrl.table.config.showAlertUnvisible = false;
    };

    $ctrl.filterResumoNEncontradas = function () {
      if ($ctrl.table.config.naoEncontradas == 0) {
        return false;
      }

      if (!$ctrl.table.config.showNotFound) {
        $ctrl.table.config.page = 1;
      }
      if ($ctrl.table.config.page === 1) {
        $ctrl.table.config.notFound = [];
      }
      enableDisableLoading("page", true);
      var offset =
        $ctrl.table.config.page > 1 ? $ctrl.table.config.notFound.length : 0;
      var limit = $ctrl.table.config.limitPerPage;

      $ctrl.table.config.showNotFound = true;
      $ctrl.table.config.showAtrasadas = false;
      $ctrl.table.config.showAlertUnvisible = false;

      Historico.getNaoEncontradas(offset, limit)
        .then(function (data) {
          $ctrl.table.config.notFound = $ctrl.table.config.notFound.concat(
            data.naoEncontradas
          );
          $ctrl.table.config.total = data.total;
          $ctrl.table.config.pages = Math.ceil(
            data.total / $ctrl.table.config.limitPerPage
          );
          $ctrl.table.config.totalItems = data.naoEncontradas.length;
          enableDisableLoading(["page", "btnLoading"], null);
        })
        .catch(function (err) {
          console.log(err);
        });

      _trackEvents(
        {
          userId: localStorageService.get("user").email,
          action: "click",
          name: "notfound",
        },
        "Module:Ocorrencia:Filter"
      );
    };

    $ctrl.filterResumoAtraso = function (click, currentFilter) {
      if (click) {
        $ctrl.table.config.page = 1;
      }
      if ($ctrl.table.config.page === 1) {
        $ctrl.table.config.packages = [];
        $ctrl.table.config.notFound = [];
      }
      $ctrl.table.config.showNotFound = false;
      $ctrl.table.config.showAtrasadas = true;
      $ctrl.table.config.hideColumnVisible = true;
      $ctrl.table.config.showAlertUnvisible = false;

      enableDisableLoading("page", true);

      var offset = $ctrl.table.config.page > 1 ? $ctrl.table.config.packages.length : 0;
      var limit = $ctrl.table.config.limitPerPage;

      Historico.getAtrasadas(offset, limit, currentFilter)
        .then(function (packages) {
          $ctrl.table.config.packages = $ctrl.table.config.packages.concat(packages.encomendas);
          $ctrl.table.config.totalItems = $ctrl.table.config.packages.length;
          $ctrl.table.config.total = packages.quantidade;
          $ctrl.table.config.pages = Math.ceil(
            packages.quantidade / $ctrl.table.config.limitPerPage
          );

          for (var pkg in packages.encomendas) {
            if (!packages.encomendas[pkg].rastreamentoRemessa) {
              var pkgDate = new Date(
                packages.encomendas[pkg].frete.dataPrevisaoEntrega
              );
              var today = new Date();
              var timeDiff = today - pkgDate;
              if (Math.floor(timeDiff / (1000 * 3600 * 24)) > 1) {
                packages.encomendas[pkg].situacaoAtraso = "Encomenda atrasada";
              } else {
                packages.encomendas[pkg].situacaoAtraso = "Possível atraso";
              }
            }
          }
          enableDisableLoading(["page", "btnLoading"], null);
        })
        .catch(function (err) {
          $ctrl.table.config.showAlertUnvisible = false;
          $ctrl.table.config.totalItems = 0;
          enableDisableLoading(["page", "btnLoading"], null);
          $ctrl.table.config.packages = [];
          $ctrl.table.config.notFound = [];
          $ctrl.table.config.total = 0;
        });

      _trackEvents(
        {
          userId: localStorageService.get("user").email,
          action: "click",
          name: "delayed",
        },
        "Module:Ocorrencia:Filter"
      );
    };

    $ctrl.filterResumo = function (classification, situation) {
      if ($ctrl.table.config.showNotFound) {
        $ctrl.table.config.page = 1;
      } else if ($ctrl.table.config.showAtrasadas) {
        $ctrl.table.config.page = 1;
      }
      $ctrl.table.config.showNotFound = false;
      $ctrl.table.config.showAtrasadas = false;
      $ctrl.filter.global.current = {
        classificacoes: classification,
        situacoes: situation,
      };
      $ctrl.columnFilters.data.data = {
        classificacoes: classification,
        situacoes: situation,
      };

      var _name = "";
      var _classification = "";
      if (classification === "Ação pendente") {
        _classification = "pendingaction";
        _name = situation === "Enviada" ? "shipped" : "notshipped";
      } else {
        _classification = "notification";
        _name = situation === "Enviada" ? "shipped" : "notshipped";
      }

      _trackEvents(
        {
          userId: localStorageService.get("user").email,
          action: "click",
          classification: _classification,
          name: _name,
        },
        "Module:Ocorrencia:Filter"
      );
    };

    $ctrl.filterDate = function (timestamp) {
      return $filter("myFormatDate")(timestamp);
    };

    $ctrl.fetchData = function (currentFilter) {
      enableDisableLoading(["page", "btnLoading"], true);
      if (_.isPlainObject(currentFilter)) {
        $ctrl.table.config.page = 1;
        $ctrl.filter.global.current = currentFilter;
      }
      if ($ctrl.table.config.showNotFound) {
        $ctrl.filterResumoNEncontradas();
      } else if ($ctrl.table.config.showAtrasadas) {
        $ctrl.filterResumoAtraso(false, currentFilter);
      } else {
        loadData();
      }
    };

    function clearResumo() {
      var radioNodes = document.querySelectorAll(".radioFilter");
      var radioToReset = Array.prototype.slice
        .call(radioNodes)
        .findIndex(function (c) {
          return c.checked;
        });

      if (radioNodes[radioToReset]) {
        radioNodes[radioToReset].checked = false;
      }
    }
    $ctrl.clear = function () {
      clearResumo();
      $ctrl.columnFilters.data = {};
      $ctrl.table.config = angular.copy($ctrl.table.reset);
      $ctrl.filter.global = angular.copy($ctrl.filter.reset);
      enableDisableLoading("page", true);
      loadData();
    };

    $ctrl.nextPage = function () {
      $ctrl.table.config.page += 1;
      $ctrl.fetchData();
      var eventParams = {
        type: "issues",
        email: localStorageService.get("user").email,
        action: "click",
        actionName: "viewNextPage",
      };
      _trackEvents(eventParams);
    };

    $ctrl.onHandleClick = function (pckg) {
      var eventParams = {
        type: "issues",
        email: localStorageService.get("user").email,
        trackId: pckg.rastreamento.codigoMandae,
        action: "click",
        actionName: "viewTracking",
      };
      _trackEvents(eventParams);
    };

    $ctrl.clearSelected = function () {
      $ctrl.table.config.selected = [];
    };

    $ctrl.printLabels = function (labels) {
      enableDisableLoading("printLabels", true);
      PrintLabel.getLabelsToPrint(labels)
        .then(function () {
          enableDisableLoading("printLabels", null);
        })
        .catch(function () {
          enableDisableLoading("printLabels", null);
        });
    };

    function _trackEvents(config, evt) {
      evt = evt || "Historical";
    }

    function _getPanelPosition(evt) {
      return $ctrl._mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .addPanelPosition(
          $ctrl._mdPanel.xPosition.CENTER,
          $ctrl._mdPanel.yPosition.ALIGN_TOPS
        );
    }

    function _close() {
      if ($ctrl.isOpenDetail) {
        $ctrl.isOpenDetail.close();
      }
    }

    function _createPanel(ev, id, customPanelConfig) {
      var opts = customPanelConfig || {};
      var selectedPackage = _.find(
        $ctrl.table.config.packages,
        function (packageData) {
          return packageData.id === id;
        }
      );

      var $elem = $(ev.currentTarget).parent().parent();
      if ($elem.is("td")) {
        $elem = $elem.parent();
      }
      $elem.addClass("bg-softgrey");

      var defaultPanelconfig = {
        attachTo: angular.element(document.body),
        template: require("./details-panel/details.html"),
        controller: "DetailsCtrl",
        controllerAs: "ctrl",
        panelClass: "detail-panel",
        position: _getPanelPosition(ev),
        locals: {
          data: selectedPackage,
        },
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        onCloseSuccess: function (mdPanelRef, closeReason) {
          if (!closeReason) {
            return;
          }
          angular.element("table.m-table tr").removeClass("bg-softgrey");
        },
      };

      var config = _.assign({}, defaultPanelconfig, opts);
      if ($ctrl.isOpenDetail !== null) {
        _close();
      }


      $ctrl._mdPanel.open(config).then(function (panelRef) {
        $ctrl.isOpenDetail = panelRef;
      });
    }

    $ctrl.openShippingDetail = function (ev, pckg) {
      var config = {
        type: "issues",
        email: localStorageService.get("user").email,
        trackId: pckg.rastreamento.codigoMandae,
        action: "click",
        actionName: "viewTrackTimeline",
      };
      _createPanel(ev, pckg.id);
      _trackEvents(config);
    };

    $ctrl.openStatusPanel = function (evt, pckg) {
      $ctrl.teste = evt;
      var settings = {
        controller: StatusPanelController,
        template: require("./status-panel/status-panel.html"),
        panelClass: "detail-panel",
      };
      var eventParams = {
        type: "issues",
        email: localStorageService.get("user").email,
        trackId: pckg.rastreamento.codigoMandae,
        action: "click",
        actionName: "viewSituation",
      };
      _createPanel(evt, pckg.id, settings);
      _trackEvents(eventParams);
    };

    $ctrl.showInsurance = function (value) {
      if (!value) {
        return "Sem seguro";
      }
      return "Seguro: " + $filter("finance")(value, true);
    };

    function _showSuccessToast(pckg) {
      var text;
      if (pckg) {
        // escondido
        text = "Ignorar ocorrência";
      } else {
        // visível
        text = "Seguir ocorrência";
      }
      var toast = $mdToast
        .simple()
        .textContent(text)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position("top right")
        .hideDelay(5000);
      return $mdToast.show(toast);
    }

    function _undoDismiss() {
      Pedido.undoDismiss($ctrl.removedPckg.id).then(
        function () {
          $ctrl.table.config.packages.splice(
            $ctrl.removedPckg.index,
            0,
            $ctrl.removedPckg
          );
          $ctrl.removedPckg.isRemoved = false;
          $ctrl.table.config.total++;
          _trackEvents({
            type: "issues",
            email: localStorageService.get("user").email,
            trackId: $ctrl.removedPckg.rastreamento.codigoMandae,
            action: "click",
            actionName: "UndoDismiss",
          });
        },
        function () {
          console.log("Error API Pedido: DELETE /aceite");
        }
      );
    }

    var editPanelListener = $rootScope.$on(
      "editPanel:show",
      function (event, pckg) {
        $ctrl.showEditPanel($ctrl.teste, pckg);
      }
    );

    var editReload = $rootScope.$on("reload", function () {
      reload();
    });

    var closeModalEvent = $rootScope.$on("closeModal", function () {
      $ctrl.isOpenDetail.close();
    });

    var editReload = $rootScope.$on("refresh:nao_encontrada", function () {
      loadData();
      $ctrl.filterResumoNEncontradas();
    });

    var sideNavListener = $rootScope.$on(
      "ticket_form:show",
      function (event, data) {
        $ctrl.ticketForm = data;
        $ctrl.ticketForm.email = localStorageService.get("user").email;
        $ctrl.ticketEmail = null;
        $ctrl.ticketSelectedEmail = null;
        Cliente.getContatos(localStorageService.get("user").id)
          .then(function (c) {
            $ctrl.ticketContatos = c;
            $mdSidenav("ticket-form").open();
          })
          .catch(function (e) {
            console.error(e);
          });
      }
    );

    var sideNavRegistrationShowListener = $rootScope.$on(
      "manual_registration:show",
      function (ev, data) {
        $ctrl.naoEncontradaSelecionada = data;
        $mdSidenav("corrigir-nao-encontrada")
          .open()
          .then(function (instance) {
            instance.onClose(function () {
              $ctrl.naoEncontradaSelecionada = null;
            });
          });
      }
    );

    var sideNavRegistrationCloseListener = $rootScope.$on(
      "manual_registration:close",
      function () {
        $ctrl.closeSidenavNaoEncontrada();
      }
    );

    $ctrl.fetchTicketEmails = function () {
      return $ctrl.ticketContatos;
    };

    $ctrl.closeTicketForm = function () {
      $mdSidenav("ticket-form").close();
    };

    $ctrl.closeSidenavNaoEncontrada = function () {
      $mdSidenav("corrigir-nao-encontrada").close();
    };

    $ctrl.submitTicketForm = function (form) {
      if (!form.$valid) {
        return;
      }

      $ctrl.processandoTicket = true;

      var mensagemComAnexo = form.extras.$modelValue;
      var email = $ctrl.ticketEmail.email;
      var showToast = function (ticketId) {
        $mdToast.show(
          $mdToast
            .simple()
            .position("top right")
            .textContent(
              "Recebido: Confira a resposta da solicitação " +
                ticketId +
                " no e-mail " +
                email
            )
        );
      };

      var newTicket = new AtendimentoResource({
        comment: mensagemComAnexo,
        tags: ["origem-paineldeocorrencias"],
        trackingCode: $ctrl.ticketForm.trackingCode,
        subject: $ctrl.ticketForm.incident,
        contactEmail: email,
        courier: $ctrl.ticketForm.shipping,
        divergenceType: $ctrl.ticketForm.incident,
        occurrenceType: $ctrl.ticketForm.incident,
      });

      newTicket.$save().then(function (data) {
        newTicket.id = data.id;
        if (data.$resolved) {
          if ($ctrl.ticketForm.shipping === "Mandae") {
            _trackEvents(
              {
                userId: localStorageService.get("user").email,
                emailZendesk: email,
                divergencia: localStorageService.get("user").email,
                trackingId: $ctrl.ticketForm.trackingCode,
              },
              "Module:Ocorrencia:CreateTicket"
            );
          } else {
            _trackEvents(
              {
                userId: localStorageService.get("user").email,
                emailZendesk: email,
                ocorrencia: localStorageService.get("user").email,
                trackingId: $ctrl.ticketForm.trackingCode,
              },
              "Module:Ocorrencia:CreateTicket"
            );
          }
          $mdSidenav("ticket-form").close();
          if ($ctrl.table.config.showNotFound) {
            $ctrl.filterResumoNEncontradas();
          } else if ($ctrl.table.config.showAtrasadas) {
            $ctrl.table.config.showAtrasadas = false;
            $ctrl.filterResumoAtraso();
          } else {
            loadData();
          }
          showToast(newTicket.id);
          $ctrl.processandoTicket = false;
        }
      }).catch(function(error) {
        console.log("Error submitting ticket:", error);
        $ctrl.processandoTicket = false;
        $mdSidenav("ticket-form").close();
      });
    };

    $ctrl.visibleToggle = function (pckg) {
      var packageId = pckg.rastreamentoRemessa.id;
      Pedido.visibleToggle(packageId).then(
        function (data) {
          var _visibleToggle = "";
          if (data.dataHoraAceiteOcorrencia) {
            _visibleToggle = "ignoreissue";
            pckg.rastreamentoRemessa.dataHoraAceiteOcorrencia = true;
            if ($ctrl.table.config.visibleFilter == "visible") {
              pckg.isHideByFilter = true;
            }
          } else {
            _visibleToggle = "notignoreissue";
            pckg.rastreamentoRemessa.dataHoraAceiteOcorrencia = null;
          }

          _trackEvents(
            {
              email: localStorageService.get("user").email,
              trackId: pckg.rastreamento.codigoMandae,
              action: "click",
              name: _visibleToggle,
            },
            "Module:Ocorrencia:Filter"
          );

          _showSuccessToast(
            pckg.rastreamentoRemessa.dataHoraAceiteOcorrencia
          ).then(function (response) {
            if (response === "ok") {
              _undoDismiss();
            }
          });
        },
        function () {
          console.log("Error API Pedido: POST /aceite");
        }
      );
    };

    $ctrl.columnFilters = { data: {} };

    $ctrl.isAddressDivergence = function (rastreamentoRemessa) {
      return [
        "Endereço incorreto - CEP do destinatário",
        "Endereço incorreto - UF do destinatário",
        "Endereço incorreto - Bairro do destinatário",
        "Endereço incorreto - Número do endereço",
        "Endereço incorreto - Logradouro do destinatário",
      ].includes(rastreamentoRemessa);
    };

    function isInvoiceDivergence(rastreamentoRemessa) {
      return [
        'Documento fiscal divergente ou inválido',
        'Documento fiscal cancelado',
        'Documento fiscal não registrado',
        'Documento fiscal anexado de forma incorreta',
        'Falha ao ler o documento fiscal',
        'Sem documento fiscal impresso',
        'Chave do documento fiscal impresso é diferente da chave cadastrada'
      ].includes(rastreamentoRemessa);
    }

    $ctrl.showEditPanel = function (evt, pckg) {
      if (isInvoiceDivergence(pckg.rastreamentoRemessa.descricaoEvento)) {
        var settings = {
          controller: "EditPanelCtrl",
          template: require("./status-panel/edit-panel.html"),
          panelClass: "detail-panel",
        };
        _createPanel(evt, pckg.id, settings);
      } else {
        var dataObj = {
          id: pckg.id,
          trackingCode: pckg.rastreamento.codigoMandae,
          shipping: "",
          incident: pckg.rastreamentoRemessa.descricaoEvento,
          trackingUrl: "",
          extras: "",
        };
        $rootScope.$emit("ticket_form:show", dataObj);
      }

      var eventParams = {
        type: "issues",
        email: localStorageService.get("user").email,
        trackId: pckg.rastreamento.codigoMandae,
        action: "click",
        actionName: pckg.rastreamentoRemessa.descricaoEvento,
      };
      _trackEvents(eventParams);
    };

    $ctrl.showDeliveryPanel = function (evt) {
      var config = {
        controller: "DeliveryFilterCtrl",
        controllerAs: "$ctrl",
        template: require("./filter-panel/delivery-filter.html"),
        locals: {
          filters: $ctrl.columnFilters.data,
        },
      };
      _createPanel(evt, null, config);
    };

    $ctrl.showVisiblePanel = function (evt) {
      var config = {
        controller: "FilterVisibleCtrl",
        controllerAs: "$ctrl",
        template: require("./filter-panel/filter-visible.html"),
        locals: {
          filters: $ctrl.columnFilters.data,
        },
      };
      _createPanel(evt, null, config);
    };

    $ctrl.showPanelNotFound = function (evt, pckg) {
      var config = {
        controller: "NotFoundPanelCtrl",
        template: require("./status-panel/notfound-panel.html"),
        locals: {
          encomenda: pckg,
          filters: {
            detectado: $ctrl.filterDate(pckg.datahoraCriacao),
          },
        },
      };
      _createPanel(evt, pckg.id, config);
    };

    $ctrl.showStatusPanel = function (evt) {
      var config = {
        controller: "StatusFilterCtrl",
        controllerAs: "$ctrl",
        template: require("./filter-panel/status-filter.html"),
        locals: {
          filters: $ctrl.columnFilters.data,
        },
      };
      _createPanel(evt, null, config);
    };

    $ctrl.success = function (content) {
      reload();
      $ctrl.showAlert(content);
    };

    $ctrl.showAlert = function (content) {

      const toast = $ctrl._mdToast
        .simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position("top right")
        .hideDelay(5000);

      return $ctrl._mdToast.show(toast);
    };

    $ctrl.mudarOrdenacao = function () {
      if ($ctrl.ordenacao === "asc") {
        $ctrl.ordenacao = "desc";
      } else {
        $ctrl.ordenacao = "asc";
      }

      $ctrl.table.config.packages = lodash.orderBy(
        $ctrl.table.config.packages,
        "entrega.tentativa",
        $ctrl.ordenacao
      );
    };

    function reload() {
      loadData();
      enableDisableLoading("page", true);
    }

    $scope.$watch(
      "$ctrl.columnFilters.data",
      function (newValue) {
        if (newValue.data && newValue.data.visible) {
          $ctrl.table.config.visibleFilter = "visible";
          if (Object.keys(newValue.data).length == 1) {
            return;
          }
        } else if (newValue.data && newValue.data.all) {
          $ctrl.table.config.visibleFilter = "all";
          if (Object.keys(newValue.data).length == 1) {
            return;
          }
        }

        $ctrl.table.config.showAlertUnvisible = false;
        if (!newValue || _.isEmpty(newValue)) {
          return;
        }
        clearResumo();
        if (
          $ctrl.filter.global.current &&
          $ctrl.filter.global.current.hasOwnProperty("tentativaEntrega") &&
          $ctrl.filter.global.current.hasOwnProperty("atrasada") &&
          Object.keys(newValue.data).length > 0
        ) {
          $ctrl.filter.global.current = newValue.data;
        } else {
          $ctrl.filter.global.current = _.assign(
            {},
            $ctrl.filter.global.current,
            newValue.data
          );
        }

        $ctrl.table.config.showNotFound = false;
        $ctrl.table.config.showAtrasadas = false;
        $ctrl.fetchData();
      },
      true
    );

    $scope.$on("$destroy", function () {
      _close();
    });

    $scope.$on("$destroy", sideNavListener);
    $scope.$on("$destroy", editPanelListener);
    $scope.$on("$destroy", sideNavRegistrationCloseListener);
    $scope.$on("$destroy", sideNavRegistrationShowListener);
    $scope.$on("$destroy", editReload);
    $scope.$on("$destroy", closeModalEvent);
    function startTour() {
      const stepsConfig = [
        {
          title: "Gestão de ocorrências",
          text: "Acompanhe as encomendas que precisam de atenção e corrija as ocorrências para que os itens voltem ao fluxo de entrega.",
          attachTarget: () =>
            document.querySelector("app-toolbar .mat-tab-link:nth-child(2)"),
          previous: {
            text: "Voltar",
            action: (ev, ref) => {
              ref.close("to_prev_section");
              $state.go("devolucoes", { tour: true }, { inherit: false });
            },
          },
        },
        {
          title: "Encomendas em atraso",
          text: "Acompanhe as encomendas que estão fora do prazo de entrega e veja as que estão com risco de atraso.",
          attachTarget: () =>
            document.querySelector(".svgAtrasos + .tooltipInfo"),
        },
        {
          title: "Correção necessária",
          text: "Encomendas sinalizadas como ação pendente exigem que você realize alguma correção para que ela volte ao fluxo de envio.",
          attachTarget: () =>
            document.querySelector(".svgAcoesPendentes + .tooltipInfo"),
        },
        {
          title: "Na Mandaê",
          text: "Encomendas que estão a caminho da Mandaê ou em nosso CD aguardando correção.",
          attachTarget: () =>
            document.querySelector("#radioFilter1").parentElement,
        },
        {
          title: "Com a transportadora",
          text: "Encomendas que já estão com as transportadoras, mas que possuem algum problema que inviabiliza a entrega.",
          attachTarget: () =>
            document.querySelector("#radioFilter2").parentElement,
        },
        {
          title: "Encomendas sem registro",
          text: "Itens que chegaram na Mandaê, mas que não estão registrados em sistema.",
          attachTarget: () =>
            document.querySelector("label[for=radioFilter7]").parentElement,
        },
        {
          title: "Notificações",
          text: "Apenas notificações que podem ser úteis em relação ao fluxo de entrega da encomenda.",
          attachTarget: () =>
            document.querySelector(".svgNotificacoes + .tooltipInfo"),
        },
        {
          title: "Na Mandaê",
          text: "Encomendas que estão na Mandaê e que precisam de análise. Em alguns casos, pode ser necessário que nosso time entre em contato com sua operação.",
          attachTarget: () =>
            document.querySelector("#radioFilter3").parentElement,
        },
        {
          title: "Com a transportadora",
          text: "Notificações realizadas pelas transportadoras, mas que não inviabilizam a entrega da encomenda.",
          attachTarget: () =>
            document.querySelector("#radioFilter4").parentElement,
        },
        {
          title: "Correção de ocorrência",
          text: "Clique no lápis para corrigir o quanto antes a ocorrência para que a encomenda possa retornar ao fluxo de envio.",
          attachTarget: () =>
            document.querySelector("th.md-column:nth-child(8)"),
        },
        {
          title: "Exibir encomendas",
          text: "Aqui você pode exibir ou esconder as ocorrências.",
          attachTarget: () =>
            document.querySelector("th.md-column:nth-child(9)"),
          next: {
            text: "Ir para Reversas",
            action: (ev, ref) => {
              ref.close("to_next_section");
              $state.go("reverse-list", { tour: true });
            },
          },
        },
      ];

      const steps = $tour.makeTour(stepsConfig);

      $tour.start(steps).subscribe();
    }
    $ctrl.isLargeScreen = function() {
      return $window.innerWidth > 1280;
    };
  }

  angular.module("mandaeApp").controller("PackagesListCtrl", PackagesListCtrl);
})();
